export interface Section {
  name: string;
  steps: number;
  order: number;
}

export interface Sections {
  intro: Section;
  factors: Section;
}

export type SectionName = keyof Sections;

export const SECTIONS: Sections = {
  intro: {
    name: "Intro",
    steps: 2,
    order: 0,
  },
  factors: {
    name: "Factores",
    steps: 4,
    order: 1,
  },
};
